module.exports = __webpack_public_path__ + "static/120x120-9e33af0a10a13c341567120d658852a8.svg";